module.exports = __webpack_public_path__ + "img/statusline.b0c064b9.svg";